import styles from "./ProductStatusBadge.module.scss";
import {
  PRODUCT_STATUS_LABELS,
  PRODUCT_STATUS_TONE,
} from "../../features/marketplace/marketplaceConstants";

export default function ProductStatusBadge({ status, label }) {
  const tone = PRODUCT_STATUS_TONE[status] || "neutral";
  const resolvedLabel =
    label || PRODUCT_STATUS_LABELS[status] || status || "Unknown";

  return (
    <span className={`${styles.badge} ${styles[tone]}`}>
      <span className={styles.dot} />
      <span>{resolvedLabel}</span>
    </span>
  );
}
